import actionTypes from "../actionTypes";

export const FETCH_BANKS = actionTypes("FETCH_BANKS");
export const VERIFY_BANK_ACCOUNT = actionTypes("VERIFY_BANK_ACCOUNT");
export const CLEAR_BANK_VERIFY_ERROR = actionTypes("CLEAR_BANK_VERIFY_ERROR");
